import React, { useState } from 'react'
import AppBar from '@material-ui/core/AppBar'
import { makeStyles } from '@material-ui/core/styles'
import { NurseFullForm } from './pages/nurse'
import { Typography, Button } from '@material-ui/core'
import { HelperModal } from './components/helper-modal'

const useStyles = makeStyles({
  content: {
    marginTop: 120,
    marginLeft: '15vw',
    marginRight: '15vw'
  },
  tab: {
    color: 'white',
    backgroundColor: '#0871b9'
  },
  appBar: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 5,
    backgroundColor: 'white',
    height: 60,
    paddingLeft: '15vw',
    paddingRight: '15vw'
  },
  logo: {
    objectFit: 'contain',
    objectPosition: 'left center',
    height: 50
  },
  logoText: {
    paddingLeft: 15,
    marginLeft: 5,
    color: '#636363',
    textTransform: 'uppercase',
    fontSize: 30
  },
  helperButton: {
    position: 'fixed',
    marginLeft: '15vw',
    marginRight: '15vw',
    width: '70vw',
    top: '0',
    marginTop: 70,
    zIndex: 900
  }
})

export interface NurseAppProps {
  returnUrl: string;
}

export const NurseApp: React.FC<NurseAppProps> = function App(props) {
  const styles = useStyles()
  const [helperModalOpen, setHelperModalOpen] = useState(false)

  return (
    <>
      <AppBar position="fixed" className={styles.appBar} >
        <img src="./logo.png" alt="EuroMedis logo" className={styles.logo}></img>
        <Typography className={styles.logoText}>
          Deklaracja wyboru położnej POZ
        </Typography>
      </AppBar>
      <div>
        <Button color="primary" variant="contained" className={styles.helperButton} onClick={() => setHelperModalOpen(true)}>Wyświetl instrukcję wypełnienia</Button>
        <HelperModal show={helperModalOpen} onHide={() => setHelperModalOpen(false)} />

        <div className={styles.content}>
          <NurseFullForm returnUrl={props.returnUrl} />
        </div>
      </div>
    </>
  )
}

export default NurseApp;
